import { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { formatCurrency, getCurrencySymbol, getRate } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';
import { Link } from 'react-router-dom'

function UpgradeCard({ id, max_savings, name, price, features, employer_match }) {
    const { user } = useUser();
    const [rate, setRate] = useState(1);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [disable, setDisable] = useState(true);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [plan_name, setPlan_name] = useState(name);
    const [planAmount, setPlanAmount] = useState(price);
    const [sMax_savings, setSMax_savings] = useState(max_savings);
    const [sEmployer_match, setSEmployer_match] = useState(employer_match);
    const [sfeatures, setSfeatures] = useState(features);
    useEffect(() => {
      if(plan_name && sMax_savings && planAmount && sEmployer_match && sfeatures){
        setDisable(false);
      }else{
        setDisable(true);
      }
    }, [plan_name, sMax_savings, planAmount, sEmployer_match, sfeatures]);
    const currencyCode = user?.currency;
    useEffect(() => {
      let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
      return () => { isMounted = false; };
    }, [currencyCode]);
    const [loading, setLoading] = useState(false);
    const EditSubscription = () =>{
      setLoading1(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/retirement.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_editplan: true, id : id, name : plan_name, amount : planAmount, max_savings : sMax_savings, employer_match : sEmployer_match, features : sfeatures})
      })
      .then(response => response.json())
      .then(data => {
        console.log(data)
        if (data.status === "success") {
          toast.success(data.result);
          setTimeout(() => {
            window.location.href = "upgradeplan";
          }, 2000);
        }else{
          toast.error(data.message);
        }
        setLoading1(false);
      })
      .catch(err => {
        console.error(err)
        setLoading1(false);
      })
    }
    const DeleteSubscription = () =>{
      setLoading2(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/retirement.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_deleteplan: true, name : name})
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          toast.success(data.result);
          setTimeout(() => {
            window.location.href = "upgradeplan";
          }, 2000);
        }else{
          toast.error(data.message);
        }
        setLoading2(false);
      })
      .catch(err => {
        console.error(err)
        setLoading2(false);
      })
    }

    return (
      <div className="rounded-0 p-0 pb-4 position-relative" style={{background:'linear-gradient(179deg, #181d25, #0B0D10)'}}>
        {user?.user_type === "adminface" && (
          <p className="text-prime fw-semibold position-absolute" onClick={() => setIsOpen(true)} style={{cursor: 'pointer', fontSize:'14px',top:'20px',right:'20px'}}>Edit</p>
        )}
        <div className="p-3 d-flex justify-content-center mb-4" style={{backgroundColor:'#0B0D10'}}>
          <p className="mb-0 text-center d-inline-block px-4 py-1" style={{backgroundColor:'#010202'}}>{name} PLAN</p>
        </div>
        <p className="text-center text-secondary mb-0 text-uppercase" style={{fontSize:'14px'}}>Price</p>
        <div className="d-flex align-items-end justify-content-center mb-3">
          {price == 0 ? (
              <p className="mb-0" style={{fontSize:'50px'}}>FREE</p>
            ) : (
              <p className="mb-0" style={{fontSize:'50px'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(price * rate, 0)}</p>  
            )
          }
        </div>
        <div className="px-3">
          <p className="mb-0 text-secondary">Maximum Contribution <span className="mx-3 text-white">-</span> <b className="text-white">{getCurrencySymbol(user?.currency)}{formatCurrency(sMax_savings * rate, 0)}</b></p>
          <p className="mb-0 text-secondary">Employer Match <span className="mx-3 text-white">-</span> <b className="text-white">{formatCurrency(sEmployer_match)}%</b></p>
          <Link to="/plandeposit" state={{plan : name, planamount : price}} className={`myBtn w-100 rounded-0 text-center my-3 d-block`} style={{paddingTop: '15px',paddingBottom: '15px'}}>Subscribe</Link>
          <div className="text-center">
              {features
              ?.split("\n")
              .filter(f => f.trim() !== "")
              .map((feature, index) => (
                  <p key={index} className="mb-1 fw-semibold text-white" style={{fontSize: '14px', textDecoration: 'underline dotted', textUnderlineOffset: '3px'}}>{feature}</p>
              ))}
          </div>
        </div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
          <div className="d-flex align-items-center justify-content-between">
              <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>
              Edit 401(k) plan</p>
              <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
          </div>
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Plan Name:</label>
          <div className="form-control py-2">
              <input 
                type="text"
                placeholder="Lite"
                className="inputNone"
                value={plan_name}
                onChange={(e) => setPlan_name(e.target.value)}
              />
          </div>
          <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
              <input 
                type="number"
                placeholder="1000"
                className="inputNone"
                value={planAmount}
                onChange={(e) => setPlanAmount(e.target.value)}
              />
              <div
                className="fw-bold text-white d-flex align-items-center"
                style={{
                  backgroundColor: 'rgb(30, 33, 36)',
                  borderRadius: '4px',
                  padding: '6px',
                  fontSize: '14px',
                  cursor: 'pointer' 
                }}
              >
                USD
              </div>
          </div>
          <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Maximum Savings:</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
              <input 
                type="number"
                placeholder="1000"
                className="inputNone"
                value={sMax_savings}
                onChange={(e) => setSMax_savings(e.target.value)}
              />
              <div
                className="fw-bold text-white d-flex align-items-center"
                style={{
                  backgroundColor: 'rgb(30, 33, 36)',
                  borderRadius: '4px',
                  padding: '6px',
                  fontSize: '14px',
                  cursor: 'pointer' 
                }}
              >
                USD
              </div>
          </div>
          <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Employer Match:</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
              <input 
                type="number"
                placeholder="2"
                className="inputNone"
                value={sEmployer_match}
                onChange={(e) => setSEmployer_match(e.target.value)}
              />
              <div
                className="fw-bold text-white d-flex align-items-center"
                style={{
                  backgroundColor: 'rgb(30, 33, 36)',
                  borderRadius: '4px',
                  padding: '6px',
                  fontSize: '14px',
                  cursor: 'pointer' 
                }}
              >
                %
              </div>
          </div>
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Features: <small className="text-prime"> * Separate each item on a new line</small></label>
          <textarea 
            className="inputNone form-control w-100"
            value={sfeatures}
            onChange={(e) => setSfeatures(e.target.value)}
            rows={4}
          />
          <div className="d-flex align-items- justify-content-between" style={{gap: '10px'}}>
            <div className={`myBtn w-100 text-center mt-3 bg-danger`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={DeleteSubscription}>{loading2?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Delete'}</div>
            <div className={`myBtn w-100 text-center mt-3 bg-prime ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? EditSubscription : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
          </div>
        </Modal>
      </div>
    )
  }
  
  export default UpgradeCard